module.exports = __webpack_public_path__ + "img/home-1.42553bbd.webp";